import { render, staticRenderFns } from "./Slidercards.vue?vue&type=template&id=351a598d"
import script from "./Slidercards.vue?vue&type=script&lang=js"
export * from "./Slidercards.vue?vue&type=script&lang=js"
import style0 from "./Slidercards.vue?vue&type=style&index=0&id=351a598d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports